import * as types from "./actionTypes";
import axios from "axios";

export const getBookmarks = (userId, token) => (dispatch) => {
  console.log(userId, token);
  dispatch({ type: types.GET_BOOKMARK_REQUEST });
  return axios({
    method: "get",
    url: `bookmark/myBookmarks/${userId}`,
    baseURL: "http://54.206.125.24:8888/",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((r) => {
      console.log("bookmarksapi", r.data);
      dispatch({ type: types.GET_BOOKMARK_SUCCESS, payload: r.data });
    })
    .catch((err) => {
      console.log("getBooksmarks err", err);
      dispatch({ type: types.SET_BOOKMARK_FAILURE, payload: err });
    });
};

export const setBookMark = (userId, lectureId, token) => (dispatch) => {
  console.log("sdsdf", userId, lectureId, token);
  dispatch({ type: types.SET_BOOKMARK_REQUEST });
  return axios({
    method: "post",
    url: `bookmark/?userId=${userId}&lectureId=${lectureId}`,
    baseURL: "http://54.206.125.24:8888/",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((r) => {
      console.log("setBookdata", r.data);
      dispatch({ type: types.SET_BOOKMARK_SUCCESS, payload: r.data });
      dispatch(getBookmarks(userId, token));
      return types.SET_BOOKMARK_SUCCESS;
    })
    .catch((err) => {
      console.log("err setbookmark", err);
      dispatch({ type: types.SET_BOOKMARK_FAILURE, payload: err });
    });
};

export const deleteBookMark = (userId, lectureId, token) => (dispatch) => {
  dispatch({ type: types.REMOVE_BOOKMARK_REQUEST });
  return axios({
    method: "delete",
    url: `bookmark/${userId}/${lectureId}`,
    baseURL: "http://54.206.125.24:8888/",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((r) => {
      dispatch({ type: types.REMOVE_BOOKMARK_SUCCESS, payload: r.data });
      dispatch(getBookmarks(userId, token));
      return types.REMOVE_BOOKMARK_SUCCESS;
    })
    .catch((err) => {
      console.log(err);
      dispatch({ type: types.REMOVE_BOOKMARK_FAILURE, payload: err });
    });
};
